import { render, staticRenderFns } from "./CollegeTeacher.vue?vue&type=template&id=773eb612&scoped=true&lang=html&"
import script from "./CollegeTeacher.vue?vue&type=script&lang=js&"
export * from "./CollegeTeacher.vue?vue&type=script&lang=js&"
import style0 from "./CollegeTeacher.vue?vue&type=style&index=0&id=773eb612&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773eb612",
  null
  
)

export default component.exports